import React from 'react';
import './AdminInputCheckbox.scss';

interface AdminInputCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  id: string;
  required?: boolean;
  className?: string;
  helpText?: string;
}

const AdminInputCheckbox: React.FC<AdminInputCheckboxProps> = ({
  label,
  checked,
  onChange,
  name,
  id,
  required = false,
  className = '',
  helpText
}) => {
  return (
    <div className={className}>
      <div className="flex items-start">
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
          required={required}
          className="mt-1 h-4 w-4 text-gray-800 border-gray-300 rounded focus:ring-1 focus:ring-gray-800 focus:border-transparent transition duration-300"
        />
        <label htmlFor={id} className={`block text-sm text-gray-700 ${required ? 'font-semibold' : 'font-medium'}`}>
          {label}{required && <span className="text-gray-700 ml-1 relative -top-1.5">٭</span>}
        </label>
      </div>
      {helpText && (
        <small className="text-gray-500 mt-1 block ml-7">
          {helpText}
        </small>
      )}
    </div>
  );
};

export default AdminInputCheckbox;
